import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  divider: {
    width: '100%',
  },
}));
export default useStyles;
